<template>
  <div class="commonCalendar">
    <div class="calendarHeader">
      <div>{{ $t('home.Mon') }}</div>
      <div>{{ $t('home.Tue') }}</div>
      <div>{{ $t('home.Wed') }}</div>
      <div>{{ $t('home.Thu') }}</div>
      <div>{{ $t('home.Fri') }}</div>
      <div>{{ $t('home.Sat') }}</div>
      <div>{{ $t('home.Sun') }}</div>
    </div>
    <ul>
      <li v-for="(arr, inde) in dateData" :key="inde">
        <div v-for="(item, index) in arr"
             :key="index"
             @click="dayClickHandle(item)"
             :class="[
               {'active' : activeDate.day === item.day && activeDate.month === item.month && activeDate.year === item.year},
               {'isDetail': item.detailCodes.length > 0},
               {'forbid': currentMonth + 1 !== item.month}
             ]"
        >
          {{ item.day }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CommonCalendar',
  data () {
    return {
      dateData: [],
      activeDate: {},
      currentYear: '',
      currentMonth: '',
      sign: [],
      temporaryDate: ''
    };
  },
  props: {
    calendarVal: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  methods: {
    dayClickHandle (item) {
      if (this.currentMonth + 1 !== item.month) {
        this.$emit('monthChange', item);
        return;
      }
      this.activeDate = {
        ...item
      };
      this.$emit('clickHandle', item);
    },
    getDateList ({ year, month, day, calendarVal }) {
      // 日历数据信息，二维数组
      let dateList = [];
      // replace解决safari游览器解析不了'-'符号
      let currentdate = '';
      if (year && month) {
        currentdate = new Date(`${ year }-${ month }-01 00:00:00`.replace(/-/g, '/'));
      } else {
        currentdate = new Date();
      }

      if (day) {
        this.activeDate = {
          year,
          month,
          day
        };
      } else {
        this.activeDate = {};
      }

      this.currentYear = currentdate.getFullYear();
      this.currentMonth = currentdate.getMonth();

      // 获取当前月的第一天时间信息
      let firstDay = new Date(this.currentYear, this.currentMonth, 1);
      // 获取第一天是周几
      let weekDay = firstDay.getDay();
      weekDay = weekDay === 0 ? 7 : weekDay;

      // 获取从哪一天开始绘制
      // 42格子，一行7格，对应周一 ~ 周日，周一可能是上个月的最后几天，所以得计算出开始的时间
      // 开始时间 = 当前月的第一天 - (当前月第一天是周几 -1)
      // 比如当前月为2021-9, 9月1从星期3开始，得获取周1时间，也就是9月1 - 2天，得出8月30号
      let startTime = firstDay - (weekDay - 1) * 24 * 60 * 60 * 1000;

      // 绘制日历
      let row = [];
      for (let i = 0; i < 42; i++) {
        let date = new Date(startTime + i * 24 * 60 * 60 * 1000);
        let detailCode = {};
        if (calendarVal && calendarVal.length > 0) {
          detailCode = calendarVal.find(item => {
            let detailsDate = new Date(item.date);
            let detailsMonth = detailsDate.getMonth() + 1;
            let detailsDay = detailsDate.getDate();
            if (date.getMonth() + 1 === detailsMonth && date.getDate() === detailsDay) {
              return item;
            }
          });
        }
        row.push({
          date: date,
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate(),
          detailCodes: detailCode && detailCode.activityCodes ? detailCode.activityCodes : []
        });
        // 每一行7个
        if ((i + 1) % 7 === 0 && i !== 0) {
          dateList.push(row);
          row = [];
        }
      }
      this.dateData = dateList;
    }
  },
  created () {
    // this.getDateList();
  }
};
</script>

<style lang="scss" scoped>
.commonCalendar{
  width: 100%;
  >.calendarHeader{
    display: flex;
    justify-content: space-around;
    font-weight: bold;
    >div{
      width: 32px;
      height: 32px;
      text-align: center;
      color: #888888;
    }
  }
  >ul{
    li{
      display: flex;
      justify-content: space-around;
      margin-top: 20px;
      >div{
        width: 32px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border-radius: 50%;
        box-sizing: border-box;
        &:hover{
          cursor: pointer;
        }
      }
      >div:hover{
        border: 1px solid #14937B;
        color: #14937B;
        &:after {
          display: none;
        }
      }
      >.isDetail{
        position: relative;
        &:after{
          content: '';
          display: block;
          width: 6px;
          height: 6px;
          position: absolute;
          bottom: -6px;
          background: #94d5c3;
          border-radius: 50%;
          left: 50%;
          margin-left: -3px;
          //transform: translateX();
        }
      }
      >.active{
        background: #14937B!important;
        color: #ffffff!important;
        border: none!important;
        box-shadow: 1px 2px 10px 0 rgba(32, 110, 89, 0.34);
        &:after {
          display: none;
        }
      }
      >.forbid {
        color: #D8D8D8;
      }
      >.only{
        background: rgba(51,132,254,.16);
        color: #3384FE;
      }
    }
  }
}
</style>
